<template>
    <div id="Homeindex">
        <MainTabBar></MainTabBar>
        <DefaultHome></DefaultHome>

        <div>
            <router-view v-if="isRouterAlive"></router-view>
        </div>
    </div>
</template>
<script>
    import axios from 'axios'
    import MainTabBar from "../../components/content/maintabber/MainTabBar";
    import Home from "../../components/content/maintabber/Home";
    import DefaultHome from "../../components/content/maintabber/DefaultHome"
    import {GetAllRegionChainList,GetMyListDatapermission, GetMyRegionChainList} from "../../api/api";

    export default {
        name: "Homeindex",
         provide () {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                data: "",
                isRouterAlive: true
            };
        },
        components: {
            MainTabBar,
           // Home,
            DefaultHome,
        },
        mounted() {
            this.RegionService();
            this.RegionMyService();
        },
        methods: {
            reload () {
                this.isRouterAlive = false
                this.$nextTick(function () {
                    this.isRouterAlive = true
                })
            },
            GetMyDatapermission() {
                GetMyListDatapermission().then(res => {
          
                })
            },
            RegionService() {
                var that = this;
                GetAllRegionChainList().then((res) => {

                    if (res.success) {
                        var str = JSON.stringify(res.result);
                        str = str.replace(/cityList/g, "children");
                        str = str.replace(/factoryList/g, "children");
                        str = str.replace(/buildingList/g, "children");
                        str = str.replace(/labList/g, "children");
                        str = str.replace(/deviceList/g, "children");
                        str = str.replace(/id/g, "value");
                        str = str.replace(/name/g, "label");
                        this.data = JSON.parse(str);
                        that.getCurrentPart(this.data);
                        this.data = JSON.stringify(this.data);
                        sessionStorage.setItem("areaListForUser", JSON.stringify(JSON.parse(this.data)[0].children));
                    } else {
                        that.$message.error(this.$t('InterfaceRequestError'));
                    }
                });
            },
            RegionMyService() {
                var that = this;
                GetMyRegionChainList().then((res) => {
     
                    if (res.success) {
                        var str = JSON.stringify(res.result);
                        // console.log(str)
                        str = str.replace(/cityList/g, "children");
                        str = str.replace(/factoryList/g, "children");
                        str = str.replace(/buildingList/g, "children");
                        str = str.replace(/labList/g, "children");
                        str = str.replace(/deviceList/g, "children");
                        str = str.replace(/id/g, "value");
                        str = str.replace(/name/g, "label");
                        this.data = JSON.parse(str);
                        that.getCurrentPart(this.data);
                        this.data = JSON.stringify(this.data);
                        sessionStorage.setItem("deviceList", this.data);
                        sessionStorage.setItem("area", JSON.stringify(JSON.parse(this.data)[0].children));
                    } else {
                        that.$message.error(this.$t('InterfaceRequestError'));
                    }
                });
            },
            getCurrentPart(items) {
                items.map((i) => {
                    if (i.children) {
                        this.getCurrentPart(i.children);
                    } else {
                        delete i.children;
                    }
                });
            },
        },
    };
</script>
<style>
    @import "~assets/css/base.css";
</style>
